/*eslint-disable*/
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { LoginCallback } from "@okta/okta-react";
// pagess
import Home from "../pages/home";
import Logout from "../pages/logout";
import Error from "../pages/error";
import UserProfile from "../pages/userProfile";
import CreateUser from "../pages/createUser";
import SearchUser from "../pages/searchUser";
import EditUser from "../pages/editUser";
import ViewUser from "../pages/viewUser";
import CreateGroup from "../pages/createGroup";
import SearchGroup from "../pages/searchGroup";
import EditGroup from "../pages/editGroup";
import ViewGroup from "../pages/viewGroup";
import ProtectedRoute from "../components/protectedRoute";
import EditMembers from "../pages/editMembers";
import BulkUsersUploadActivity from "../pages/bulkUsersUploadActivity";
import ViewBulkJob from "../pages/viewBulkJob";
import UserActivities from "../pages/userActivities";
import EditName from "../pages/editName";
import ViewReports from "../pages/viewReports";
import Faqs from "../pages/faqs"
import Health from "../pages/health";
import Support from "../pages/support/support";

function AppRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/logout" element={<Logout />} />
      <Route exact path="/health" element={<Health />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route
        path="/user-profile"
        element={
          <ProtectedRoute>
            {" "}
            <UserProfile />{" "}
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-user"
        element={
          <ProtectedRoute>
            <CreateUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/support"
        element={
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        }
      />
      <Route
        path="/search-user"
        element={
          <ProtectedRoute>
            <SearchUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-user/:userId"
        element={
          <ProtectedRoute>
            <EditUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-user/:userId"
        element={
          <ProtectedRoute>
            <ViewUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-group"
        element={
          <ProtectedRoute>
            <CreateGroup />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/search-group"
        element={
          <ProtectedRoute>
            <SearchGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-group/:groupId"
        element={
          <ProtectedRoute>
            <EditGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-group/:groupId"
        element={
          <ProtectedRoute>
            <ViewGroup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-members/:groupId"
        element={
          <ProtectedRoute>
            <EditMembers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-activities"
        element={
          <ProtectedRoute>
            <UserActivities />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bulk-users-activity"
        element={
          <ProtectedRoute>
            <BulkUsersUploadActivity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-bulk-job/:jobId"
        element={
          <ProtectedRoute>
            <ViewBulkJob/>
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-name"
        element={
          <ProtectedRoute>
            <EditName />
          </ProtectedRoute>
        }
      />
      <Route path="error" element={<Error />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default AppRoutes;
